import { createApp } from 'vue';
import { RootStore } from '@/store/RootStore';
import { RootRouter } from '@/router';
import PrimeVue from 'primevue/config';
// @ts-ignore – subpath export requires bundler moduleResolution
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import '@/style/atlas.css';
import '@/style/app.css';
import App from '@/App.vue';

// PrimeVue only renders overlays (popover, listbox, date picker); map its theme
// onto the Atlas palette so they match the rest of the UI.
const AppPreset = definePreset(Aura, {
  primitive: {
    borderRadius: { none: '0', xs: '3px', sm: '3px', md: '5px', lg: '8px', xl: '12px' },
  },
  semantic: {
    primary: {
      50: '#f1efff', 100: '#e4e0ff', 200: '#cbc4ff', 300: '#aca1ff', 400: '#8577ff',
      500: '#5b4bff', 600: '#4636e0', 700: '#3a2cc0', 800: '#30259b', 900: '#271f7a', 950: '#170f4d',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff', 50: '#f9fafb', 100: '#f3f4f6', 200: '#e5e7eb', 300: '#d1d5db', 400: '#9ca3af',
          500: '#6b7280', 600: '#4b5563', 700: '#374151', 800: '#1f2937', 900: '#111827', 950: '#030712',
        },
        highlight: { background: '#f1efff', focusBackground: '#e4e0ff', color: '#4636e0', focusColor: '#4636e0' },
      },
    },
    formField: {
      sm: {
        fontSize: '0.8125rem',
      },
    },
  },
});

createApp(App)
  .use(RootRouter)
  .use(RootStore)
  .use(PrimeVue, {
    theme: {
      preset: AppPreset,
      options: {
        darkModeSelector: false,
        cssLayer: false,
      },
    },
  })
  .mount('#app');
